import { useEffect, useState } from 'react';
import AdminSidebar from '../components/AdminSidebar';

const API_BASE = process.env.REACT_APP_API_BASE_URL || `${process.env.FRONTEND_URL}/api`;

export default function AdminProfilePage() {
  const [admin, setAdmin] = useState(null);
  const [form, setForm] = useState({ fullName: '', email: '', phone: '' });
  const [passwordForm, setPasswordForm] = useState({ current: '', next: '' });
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const token = localStorage.getItem('adminToken');

  useEffect(() => {
    fetch(`${API_BASE}/portal/profile`, { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => r.json())
      .then((json) => {
        if (json.success) {
          setAdmin(json.data);
          setForm({
            fullName: json.data.fullName || '',
            email: json.data.email || '',
            phone: json.data.phone || '',
          });
        }
      });
  }, [token]);

  const handleSaveProfile = async () => {
    setSaving(true);
    setMessage('');
    setError('');
    const res = await fetch(`${API_BASE}/portal/profile`, {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
      body: JSON.stringify(form),
    });
    const json = await res.json();
    setSaving(false);
    if (json.success) setMessage('Profile updated.');
    else setError(json.error?.message || 'Update failed.');
  };

  const handleChangePassword = async () => {
    setSaving(true);
    setMessage('');
    setError('');
    const res = await fetch(`${API_BASE}/portal/profile/password`, {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
      body: JSON.stringify({ currentPassword: passwordForm.current, newPassword: passwordForm.next }),
    });
    const json = await res.json();
    setSaving(false);
    if (json.success) {
      setMessage('Password changed.');
      setPasswordForm({ current: '', next: '' });
    } else {
      setError(json.error?.message || 'Password change failed.');
    }
  };

  if (!admin) return <p className="text-center py-40 text-[#64748b]">Loading...</p>;

  return (
    <div className="bg-[#f7f9fb] font-['Plus_Jakarta_Sans'] min-h-screen">
      <AdminSidebar />
      <main className="pt-16 md:pt-2 md:ml-64 min-h-screen p-8">
        <div className="max-w-2xl">
          <div className="flex items-center gap-4 mb-8">
            <div className="w-16 h-16 rounded-full bg-[#00255a] flex items-center justify-center text-white text-2xl font-bold">
              {admin.fullName?.charAt(0)}
            </div>
            <div>
              <h2 className="text-3xl font-bold text-[#00255a]">My Profile</h2>
              <p className="text-[#64748b]">Administrator Account</p>
            </div>
          </div>

          {message && <div className="mb-6 p-3 bg-green-50 border border-green-200 text-green-700 text-sm rounded-lg">{message}</div>}
          {error && <div className="mb-6 p-3 bg-red-50 border border-red-200 text-red-700 text-sm rounded-lg">{error}</div>}

          <section className="bg-white rounded-2xl border border-[#e2e8f0] shadow-sm p-8 mb-8">
            <h3 className="text-lg font-bold text-[#00255a] mb-6">Account Details</h3>
            <div className="space-y-6">
              <Field label="Full Name" value={form.fullName} onChange={(v) => setForm({ ...form, fullName: v })} />
              <Field label="Email Address" type="email" value={form.email} onChange={(v) => setForm({ ...form, email: v })} />
              <Field label="Phone Number" type="tel" value={form.phone} onChange={(v) => setForm({ ...form, phone: v })} />
              <button
                onClick={handleSaveProfile}
                disabled={saving}
                className="px-8 py-3 text-white font-semibold rounded-lg shadow-md disabled:opacity-60"
                style={{ background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 60%, #ff7b7b 100%)' }}
              >
                {saving ? 'Saving...' : 'Save Changes'}
              </button>
            </div>
          </section>

          <section className="bg-white rounded-2xl border border-[#e2e8f0] shadow-sm p-8">
            <h3 className="text-lg font-bold text-[#00255a] mb-6">Change Password</h3>
            <div className="space-y-6">
              <Field label="Current Password" type="password" value={passwordForm.current} onChange={(v) => setPasswordForm({ ...passwordForm, current: v })} />
              <Field label="New Password" type="password" value={passwordForm.next} onChange={(v) => setPasswordForm({ ...passwordForm, next: v })} />
              <button
                onClick={handleChangePassword}
                disabled={saving || !passwordForm.current || !passwordForm.next}
                className="px-8 py-3 bg-[#00255a] text-white font-semibold rounded-lg disabled:opacity-50"
              >
                Update Password
              </button>
            </div>
          </section>
        </div>
      </main>
    </div>
  );
}

function Field({ label, value, onChange, type = 'text' }) {
  return (
    <div>
      <label className="block text-sm font-semibold text-[#44474f] mb-2">{label}</label>
      <input
        type={type}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="w-full px-4 py-3 bg-[#f7f9fb] border border-[#e2e8f0] rounded-lg focus:ring-2 focus:ring-[#00255a]/10 focus:border-[#00255a] outline-none transition-all"
      />
    </div>
  );
}